import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin, Instagram, ArrowUpRight } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-lime text-navy">
      {/* CTA Section */}
      <div className="container-main py-16">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="max-w-xl">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight font-display">
              HAVE ANY<br />PROJECT IDEA?
            </h2>
            <p className="mt-4 text-navy/70 max-w-md text-sm leading-relaxed">
              We also reach out to the clients if they want. After hearing your requirements or plan, we deliver a detailed project proposal along with the pricing plan discussed in detail, subject to be altered based on mutual discussion.
            </p>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-navy font-medium">{companyInfo.email}</span>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-navy text-white px-6 py-3 rounded-full text-sm font-medium transition-all hover:bg-opacity-90">

              Submit
              <span className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                <ArrowUpRight className="w-4 h-4" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-navy/20">
        <div className="container-main py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <span className="font-display !font-bold !text-xl">TEEKAY LLC</span>
            
            <div className="flex items-center gap-8">
              <Link to="/terms" className="text-sm font-medium hover:underline">Terms</Link>
              <Link to="/privacy" className="text-sm font-medium hover:underline">Privacy</Link>
              <Link to="/cookies" className="text-sm font-medium hover:underline">Cookies</Link>
            </div>

            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 bg-navy rounded-full flex items-center justify-center text-white hover:bg-opacity-80 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-navy rounded-full flex items-center justify-center text-white hover:bg-opacity-80 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-navy rounded-full flex items-center justify-center text-white hover:bg-opacity-80 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contact Information */}
          <div className="mt-6 pt-6 border-t border-navy/20 text-center">
            <p className="text-sm text-navy/80 mb-1">
              {companyInfo.address}
            </p>
            <p className="text-sm text-navy/80">
              <a href={`tel:${companyInfo.phone}`} className="hover:underline">{companyInfo.phone}</a>
              <span className="mx-2">|</span>
              <a href={`mailto:${companyInfo.email}`} className="hover:underline">{companyInfo.email}</a>
            </p>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;